var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn",attrs:{"disabled":_vm.submited},on:{"click":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_vm._v(" Relatório ")]),_vm._v(" "),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }